import WhatIsIt from './WhatIsIt';

export default WhatIsIt;
